<template>
  <div  class="carousel-img-button-display ">
    <p>{{title}}</p> 
    <div class="border" v-if="!clicked">
      <b-button  type="button" class="btn-carouse border" v-for="(item, index) in buttons" @click="quickReplyClick" :key="index">{{item.title}}</b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["message"],
  data() {
    return {
      title: null,
      buttons: [],
      clicked: false
    };
  },
  created() {
    this.title = this.message.message.message.text;
    this.buttons = this.message.message.message.quick_replies;
  },
  methods: {
    quickReplyClick() {
      this.clicked = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.carousel-img-button-display {
      width: 100%;
      .btn-carouse {
        width: 100%;
        height: 30px;
        padding: 5px 20px;
        border-top: 1px solid #fff !important;
        background-color: #b4b4b4 !important;
        color: #fff !important;
        border-radius: 0 0 4px 4px;
        opacity: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        outline: none;
      }
      .btn-carouse:active {
        color: #fff !important;
      }
    }

</style>